import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IWebBranch, IWebBranchState } from "./webBranchModel";
import {
  ActiveInactiveWebBranch,
  createWebBranch,
  deleteWebBranch,
  getAllActiveWebBranches,
  getAllWebBranches,
  getWebBranchByID,
  updateWebBranch,
} from "./services/webBranch.services";

const initialState: IWebBranchState = {
  loading: false,
  error: "",
  WebBranchID: null,
  WebBranchList: [],
  WebBranchDetail: {
    BranchName: "",
    EmailID: "",
    Address: "",
    CityID: null,
    MobileNo: "",
    MapURL: "",
    WorkingHours: "",
    IsActive: 1,
  },
};

const webBranchSlice = createSlice({
  name: "webBranch",
  initialState,
  reducers: {
    clearWebBranchDetails: (state) => {
      state.WebBranchDetail = initialState.WebBranchDetail;
    },
    setWebBranchID: (state, action) => {
      state.WebBranchID = action.payload;
    },
    clearWebBranchID: (state) => {
      state.WebBranchID = initialState.WebBranchID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllWebBranches.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllWebBranches.fulfilled,
      (state, action: PayloadAction<IWebBranch[]>) => {
        state.loading = false;
        state.WebBranchList = action.payload || [];
      }
    );
    builder.addCase(getAllWebBranches.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.WebBranchList = [];
    });
    builder.addCase(createWebBranch.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createWebBranch.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createWebBranch.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateWebBranch.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateWebBranch.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateWebBranch.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteWebBranch.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteWebBranch.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteWebBranch.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getWebBranchByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getWebBranchByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.WebBranchDetail = action.payload;
    });
    builder.addCase(getWebBranchByID.rejected, (state, action) => {
      state.loading = false;
      state.WebBranchDetail = initialState.WebBranchDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveWebBranches.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveWebBranches.fulfilled,
      (state, action: PayloadAction<IWebBranch[]>) => {
        state.loading = false;
        state.WebBranchList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveWebBranches.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.WebBranchList = [];
    });
    builder.addCase(ActiveInactiveWebBranch.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveWebBranch.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveWebBranch.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearWebBranchDetails, clearWebBranchID, setWebBranchID } =
  webBranchSlice.actions;
export default webBranchSlice.reducer;
